import styled from "styled-components";
  
export const UTMGeneratorContainer = styled.div`
  display:flex;
  flex-direction:column;
`;
  